import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryV1 } from './baseQueryV1';
export const taxApi = createApi({
  reducerPath: 'taxApi',
  baseQuery: baseQueryV1,
  endpoints: (builder) => ({
    getTaxes: builder.query({
      query: (params) => ({
        url: 'tax',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => res?.data,
    }),

    addTax: builder.mutation({
      query: (payload) => ({
        url: 'tax',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),

    updateTax: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `tax/${id}`,
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),

    deleteTax: builder.mutation({
      query: (id) => ({
        url: `tax/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const { useGetTaxesQuery, useAddTaxMutation, useUpdateTaxMutation, useDeleteTaxMutation } =
  taxApi;
